import Modal, { ModalProps } from 'components/containers/Modal/Modal';
import Flow from 'components/generics/flows/Flow';
import useAuth from 'context/Auth';
import { FREEZE_ACCOUNT } from 'graphql/user/mutations/freezeAccount';
import { useLandaApiMutation } from 'hooks/api/graphql/landa_api';
import DeleteAccountConfirm from 'pages/profile/components/ProfileTabContent/Account/Advanced/components/DeleteAccountModalFlow/DeleteAccountConfirm';
import DeleteAccountReview from 'pages/profile/components/ProfileTabContent/Account/Advanced/components/DeleteAccountModalFlow/DeleteAccountReview';
import DeleteAccountSteps from 'pages/profile/components/ProfileTabContent/Account/Advanced/components/DeleteAccountModalFlow/DeleteAccountSteps';
import classes from './index.module.scss';

type Props = ModalProps;

const DeleteAccountModalFlow = (props: Props) => {
  const [freezeAccount] = useLandaApiMutation(FREEZE_ACCOUNT);
  const { logout } = useAuth();

  const components = [
    { component: DeleteAccountSteps },
    { component: DeleteAccountReview },
    { component: DeleteAccountConfirm },
  ];

  const onFinish = async ({ reasons }: { reasons: string[] }) => {
    await freezeAccount({
      variables: {
        reasons: reasons || [],
      },
    });
    logout();
    props?.onClose?.();
  };

  return (
    <Modal
      className={classes.container}
      {...props}
    >
      <Flow
        components={components}
        onFinish={onFinish}
      />
    </Modal>
  );
};
export default DeleteAccountModalFlow;
